export const IS_APP = window.location.search.includes('target=app');
export const IS_EMBEDED = IS_APP;



// WEBPACK FOOTER //
// ./src/services/target.js